import { SyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useNavigate, useOutletContext } from 'react-router'

import { PublicRoutes, SetupWorkspaceRoutes } from 'app/application/types'
import { ArrowRightIcon } from 'app/common/presentation/icons'

import { Button, Input } from 'components'

import accessStyles from '../AccessPage/AccessPage.module.scss'
import { UserAccessContext, isCreateWorkspaceInput } from './CreateAccess'

const SetupWorkspace = () => {
  const { t } = useTranslation('user')
  const navigate = useNavigate()
  const { error, formInput, handleCreateWorkspace, loggedIn, setFormInput } =
    useOutletContext<UserAccessContext>()

  if (!isCreateWorkspaceInput(formInput)) {
    return <Navigate to={PublicRoutes.CreateWorkspace} replace />
  }

  const handleSubmit = (event: SyntheticEvent) => {
    event.preventDefault()
    if (!formInput.workspace.trim() || error || loggedIn === undefined) return
    if (loggedIn) {
      handleCreateWorkspace()
    } else {
      void navigate({
        pathname: `${PublicRoutes.CreateWorkspace}/${SetupWorkspaceRoutes.SignUp}`,
        search: new URLSearchParams({
          email: formInput.email,
          inviteCode: formInput.inviteCode,
        }).toString(),
      })
    }
  }

  return (
    <>
      <div>
        <h1>{t('workspaceSetup.title')}</h1>
        <div className={accessStyles.message}>{t('workspaceSetup.description')}</div>
      </div>
      <form onSubmit={handleSubmit}>
        <Input
          autoFocus
          error={error}
          label={t('workspaceSetup.name')}
          mandatory
          onChange={(workspace) => setFormInput((previous) => ({ ...previous, workspace }))}
          placeholder={t('workspaceSetup.placeholder')}
          value={formInput.workspace}
        />
        <Button
          disabled={!!error || loggedIn === undefined || !formInput.workspace.trim()}
          rightIcon={<ArrowRightIcon />}
          type="submit"
        >
          {t('workspaceSetup.create')}
        </Button>
      </form>
    </>
  )
}

export default SetupWorkspace
